import React, {Fragment} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {getMessage} from "./util";

const version = require('../package.json');


const Footer = (props) => {

    return (
        <Fragment>

            <Row className="justify-content-center EvColorBlue pb-4 pt-4 mt-4">
                {/*<Col xs={2} sm={1} className={"text-right"}>*/}
                {/*    <img className="img-max-100" src={logo} alt="footer"/>*/}

                {/*</Col>*/}
                <Col xs={12} md={6} className={"text-white font-weight-bold"}>
                    <Row className={"m-1"}>
                        <Col>
                            {getMessage('support', props.messages)}:
                        </Col>
                    </Row>
                    <Row className={"m-1"}>
                        <Col sm={12} >
                            {getMessage('support_mail', props.messages)}
                        </Col>
                        <Col className={"mt-2"} sm={12}>
                            {/*Si solicita soporte via WhatsApp<a className="EvWhatsAppSupport text-white" href="https://api.whatsapp.com/send/?phone=56984490669" target="_blank">Presione aquí</a>.*/}
                            <Button className="EvColorGrisLight btn-wsp" target="_blank" href="https://api.whatsapp.com/send/?phone=56984490669"
                                    variant="light">
                                <span className="iconVote"></span>
                                <span>Soporte</span>
                            </Button>
                        </Col>
                    </Row>
                    {/*<Row className={"m-1"}>*/}
                    {/*    <Col >*/}
                    {/*        <small>{getMessage('footer_message', props.messages)}</small>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                </Col>
            </Row>
            <Row>
                <Col className="text-right">
                    <small> v. {version.version}</small>
                </Col>
            </Row>
        </Fragment>
    );
}


export default Footer;